<template>
  <div>
    <div>
      <div class="scanbox">
        <div class="scanboxTwo"></div>
      </div>
      <div class="scanBtnOpacity"></div>
      <div class="scanBtn" v-on:click="openScan"><img src="/static/images/scan.png"></div>
      <div class="scanText"><i>点击上方扫一扫按钮查询真伪</i></div>
      <div v-text="msg"></div>
    </div>
  </div>
</template>

<script>
  var self;
  import axios from 'axios'
  import Loading from '@/components/Loading.vue'
  import ModelLoading from '@/components/ModelLoading.vue'
  export default {
    name: 'Scan',
    components: {
      'K-Loading': Loading,
      'K-ModelLoading': ModelLoading
    },
    data() {
      return {
        msg:null,
        tag: null
      }
    },
    created() {
      console.log("触发")
      //自适应像素
      var w = document.documentElement.getBoundingClientRect().width / 16
      document.documentElement.style.fontSize = w + "px"
    },
    mounted() {
      self = this;
      this.getWXInfo();
      document.querySelector("body").setAttribute("style", "background-color: #007AFF");
    },
    beforeDestroy() {
      document.querySelector("body").removeAttribute();
    },
    methods: {
      getWXInfo: function() {
        let param = new URLSearchParams()
        param.append('syid', "100010034")
        param.append('url', window.location.href)
        axios({
          method: 'post',
          data: param,
          url: "https://sale.oid.plus/v1/wechat-public/js-ticket",
        }).then(function(res) {
          var json = res.data;
          // self.msg = json //调试
          if (json.code == 200) {
            self.msg = json.data.appId
            wx.config({
              debug: true,
              appId: json.data.appId,
              timestamp: json.data.timestamp,
              nonceStr: json.data.nonceStr,
              signature: json.data.signature,
              jsApiList: ['scanQRCode']
            });
          }
        }).catch(function(error) {
          console.log(error);
        })
      },
      openScan: function() {
        wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
          success: function(res) {
            var tag = tagFiltration(res.resultStr);
            self.tag = tag;
            window.location.href = "https://lj.oid.plus?" + tag
          }
        });
      }
    }
  }
</script>

<style scoped>
  .scanBtn {
    width: 4rem;
    height: 4rem;
    border-radius: 4rem;
    overflow: hidden;
    display: table;
    background-color: #FFFFFF;
    position: fixed;
    top: 7.5rem;
    left: 6rem;
    z-index: 99;
  }

  .scanBtnOpacity {
    width: 5rem;
    height: 5rem;
    border-radius: 5rem;
    overflow: hidden;
    display: table;
    background-color: #FFFFFF;
    position: fixed;
    top: 7rem;
    left: 5.5rem;
    animation: opacity 6s infinite;
    -webkit-animation: opacity 6s infinite;
    /*Safari and Chrome*/
    animation-timing-function: linear;
    z-index: 98;
  }

  .scanBtn img {
    width: 2rem;
    height: 2rem;
    display: table;
    margin: 1rem auto;
  }

  .scanbox {
    width: 7rem;
    height: 7rem;
    position: fixed;
    left: 4.5rem;
    top: 6rem;
    border-radius: 7rem;
    border-left: .1rem dashed #FFF;
    animation: rotate 10s infinite;
    -webkit-animation: rotate 10s infinite;
    /*Safari and Chrome*/
    animation-timing-function: linear;
    opacity: 0.7;
  }

  .scanboxTwo {
    width: 6rem;
    height: 6rem;
    margin: .5rem auto;
    display: table;
    overflow: hidden;
    border-radius: 6rem;
    border-top: .05rem solid #FFF;
    border-right: .05rem solid #FFF;
    animation: rotate 6s infinite;
    -webkit-animation: rotate 6s infinite;
    /*Safari and Chrome*/
    animation-timing-function: linear;
  }

  @keyframes rotate {
    0% {
      -webkit-transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      transform: rotate(0deg);
    }

    100% {
      -webkit-transform: rotate(360deg);
      -ms-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @-webkit-keyframes rotate {
    0% {
      -webkit-transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      transform: rotate(0deg);
    }

    100% {
      -webkit-transform: rotate(360deg);
      -ms-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @-moz-keyframes opacity {
    0% {
      opacity: 1;
    }

    50% {
      opacity: 0.6;
    }

    100% {
      opacity: 1;
    }
  }

  @-webkit-keyframes opacity {
    0% {
      opacity: 1;
    }

    50% {
      opacity: 0.6;
    }

    100% {
      opacity: 1;
    }
  }

  .splitbox {
    height: .4rem;
    background-color: #EFEFEF;
  }

  .scanText {
    position: fixed;
    top: .5rem;
    left: 0;
    right: 0;
    color: #fff;
    font-size: .7rem;
    text-align: center;
    padding-top: 14rem;
  }

  .scanText i {
    display: table;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/public-view/Scan.vue